<!-- @format -->

@if (hasInvalidSelections) {
  <div class="invalid-selections">
    <h4 translate>SIS_COMPONENTS.PLAN.INVALID_SELECTIONS.TITLE</h4>
    <div class="rule-body">
      @for (courseUnit of invalidCourseUnitSelections; track courseUnit) {
        <div>
          <sis-plan-course-unit
            [courseUnit]="courseUnit"
            [planValidationResult]="planValidationResult"
            [planStateObject]="planStateObject"
            [planData]="planData"
            [parentModule]="parentModule">
            <div course-unit-action class="additional-box">
              <sis-button
                class="button-box"
                [link]="true"
                (clicked)="removeCourseUnit(courseUnit)"
                [ariaLabel]="'ARIA_LABEL.DELETE' | translate">
                <sis-icon icon="delete"></sis-icon>
              </sis-button>
            </div>
          </sis-plan-course-unit>
        </div>
      }
      @for (module of invalidModuleSelections; track module) {
        <div>
          <sis-rule-module-box
            [module]="module"
            [planValidationResult]="planValidationResult"
            [planStateObject]="planStateObject"
            [planData]="planData">
            <div module-action class="additional-box">
              <sis-button class="button-box" [link]="true" (clicked)="removeModule(module)" [ariaLabel]="'ARIA_LABEL.DELETE' | translate">
                <sis-icon icon="delete"></sis-icon>
              </sis-button>
            </div>
          </sis-rule-module-box>
        </div>
      }
      @for (customCourseUnitAttainment of invalidCustomCourseUnitAttainmentSelections; track customCourseUnitAttainment) {
        <div>
          <sis-plan-custom-course-unit-attainment
            [customCourseUnitAttainment]="customCourseUnitAttainment"
            [planStateObject]="planStateObject">
            <div custom-course-unit-attainment-action class="additional-box">
              <sis-button
                class="button-box"
                [link]="true"
                (clicked)="removeCustomCourseUnitAttainment(customCourseUnitAttainment)"
                [ariaLabel]="'ARIA_LABEL.DELETE' | translate">
                <sis-icon icon="delete"></sis-icon>
              </sis-button>
            </div>
          </sis-plan-custom-course-unit-attainment>
        </div>
      }
      @for (
        customCourseUnitAttainmentId of customCourseUnitAttainmentSelectionsWithInvalidAttainmentReference;
        track customCourseUnitAttainmentId
      ) {
        <div>
          <sis-plan-custom-course-unit-attainment>
            <div unknown-custom-course-unit-attainment-action class="additional-box">
              <sis-button
                class="button-box"
                [link]="true"
                (clicked)="removeCustomCourseUnitAttainmentById(customCourseUnitAttainmentId)"
                [ariaLabel]="'ARIA_LABEL.DELETE' | translate">
                <sis-icon icon="delete"></sis-icon>
              </sis-button>
            </div>
          </sis-plan-custom-course-unit-attainment>
        </div>
      }
      @for (customModuleAttainment of invalidCustomModuleAttainmentSelections; track customModuleAttainment) {
        <div>
          <sis-rule-custom-module-attainment-box
            [customModuleAttainment]="customModuleAttainment"
            [planValidationResult]="planValidationResult"
            [planStateObject]="planStateObject"
            [planData]="planData">
            <div custom-module-attainment-action class="additional-box">
              <sis-button
                class="button-box"
                [link]="true"
                (clicked)="removeCustomModuleAttainment(customModuleAttainment)"
                [ariaLabel]="'ARIA_LABEL.DELETE' | translate">
                <sis-icon icon="delete"></sis-icon>
              </sis-button>
            </div>
          </sis-rule-custom-module-attainment-box>
        </div>
      }
      @for (customModuleAttainmentId of customModuleAttainmentSelectionsWithInvalidAttainmentReference; track customModuleAttainmentId) {
        <div>
          <sis-rule-custom-module-attainment-box>
            <div unknown-custom-module-attainment-action class="additional-box">
              <sis-button
                class="button-box"
                [link]="true"
                (clicked)="removeCustomModuleAttainmentById(customModuleAttainmentId)"
                [ariaLabel]="'ARIA_LABEL.DELETE' | translate">
                <sis-icon icon="delete"></sis-icon>
              </sis-button>
            </div>
          </sis-rule-custom-module-attainment-box>
        </div>
      }
    </div>
  </div>
}
